import { takeLatest, call, put } from 'redux-saga/effects';

import { getCampaignsInsights } from './api';
import { fetchCampaignInsightsSuccess, fetchCampaignInsightsFail } from './actions';
import generalActionTypes from './action-types';

function* fetchCampaignInsightsSaga({ payload }) {
  try {
    const response = yield call(getCampaignsInsights, payload);
    yield put(fetchCampaignInsightsSuccess(response.data));
  } catch (error) {
    yield put(fetchCampaignInsightsFail(error));
  }
}

function* commonSaga() {
  yield takeLatest(generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS, fetchCampaignInsightsSaga);
}

export default commonSaga;
